import { TrackEventVerb } from '@updater/ui-tracker';

export type TrackEventVerbDict = {
  [key: string]: TrackEventVerb;
};

/**
 * @enum {Object{String}} DOMAIN
 * @description dictionary that contains the analytics domain type.
 */
export enum DOMAIN {
  UTILITIES = 'utilities',
}

/**
 * @enum {Object{String}} VERB
 * @description dictionary that contains the analytics verbs type.
 */
export enum VERB {
  CLICKED = 'clicked',
  ERRORED = 'errored',
  SUBMITTED = 'submitted',
  VIEWED = 'viewed',
}

/**
 * @enum {Object{String}} OBJECT
 * @description dictionary contains the analytics object type.
 */
export enum OBJECT {
  BACK_BUTTON = 'backButton',
  EDIT_BUTTON = 'editButton',
  CTA_BUTTON = 'ctaButton',
  UTILITIES = 'utilities',
}

/**
 * @enum {Object{String}} PAGE
 * @description dictionary contains the analytics page name.
 */
export enum PAGE {
  INDEX = 'index',
  UTILITIES = 'utilities',
}
